import React from 'react';
import { Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import { Add as AddIcon, RemoveCircleOutline as RemoveLineIcon } from '@mui/icons-material';
import { InventoryItemPicker } from './InventoryShared';

// Shared line editor for stock documents: one row per (item x qty), with an
// optional unit-cost column (receipts carry costs; issues are qty-only;
// adjustments use a signed quantity_delta with an optional cost override).
const StockLinesEditor = ({
  lines,
  setLines,
  quantityKey = 'quantity',
  quantityLabel = 'Quantity',
  allowNegative = false,
  showUnitCost = true,
  unitCostKey = 'unit_cost',
  unitCostLabel = 'Unit Cost',
  emptyLine,
}) => {
  const setLine = (index, key, value) => {
    setLines(lines.map((l, i) => (i === index ? { ...l, [key]: value } : l)));
  };
  const addLine = () => setLines([...lines, emptyLine()]);
  const removeLine = (index) => setLines(lines.filter((_, i) => i !== index));

  return (
    <>
      <Typography variant="subtitle2" gutterBottom>Lines</Typography>
      {lines.map((l, i) => (
        <Stack key={i} direction="row" flexWrap="wrap" gap={1.5} alignItems="flex-start" sx={{ mb: 1.5 }}>
          <Box sx={{ minWidth: 220, flex: '2 1 220px' }}>
            <InventoryItemPicker value={l.item_id} onChange={(id) => setLine(i, 'item_id', id)} required />
          </Box>
          <TextField
            size="small" type="number" label={quantityLabel} value={l[quantityKey] ?? ''}
            onChange={(e) => setLine(i, quantityKey, e.target.value)}
            inputProps={{ step: 'any', ...(allowNegative ? {} : { min: 0.01 }) }} sx={{ width: 140 }} required
          />
          {showUnitCost && (
            <TextField
              size="small" type="number" label={unitCostLabel} value={l[unitCostKey] ?? ''}
              onChange={(e) => setLine(i, unitCostKey, e.target.value)}
              inputProps={{ min: 0, step: 'any' }} sx={{ width: 150 }}
            />
          )}
          <IconButton size="small" color="error" title="Remove line" onClick={() => removeLine(i)} disabled={lines.length <= 1}>
            <RemoveLineIcon fontSize="small" />
          </IconButton>
        </Stack>
      ))}
      <Button size="small" startIcon={<AddIcon />} onClick={addLine}>Add line</Button>
    </>
  );
};

export default StockLinesEditor;
